import {roundToTwo} from "@/vendor/util";

export function calcCartSum(cartItems) {
  let cartSum = 0;
  let payerSum = 0;
  let takeAwayPayerSum = 0;
  let rabattSum = 0;

  let discountValue = 0;

  for (let item of cartItems) {
    if (item.amountFreeTotal) {
      // appliedCode: coupon.couponCode,
      // aaaCodeTitle: coupon.title,
      // amountFree: amountFree,
      cartSum += item.itemTotal;
      payerSum += item.itemTotal;
      takeAwayPayerSum += item.itemTotal;
      if (item.amountFreeTotal) {
        item.amountFreeTotal = item.amountFree * item.count;
      }
      rabattSum += item.amountFreeTotal;

      if (item.originalItemTotal) {
        item.originalItemTotal = (item.originalSizePrice + item.sumOfExtras) * item.count;
      }

    } else if ('isCoupon' in item) {
      if (item.type === 'amount' && item.forRedeem) {
        payerSum -= item.amount;
        takeAwayPayerSum -= item.amount;
        rabattSum += item.amount;
      } else if (item.type === 'bundle') {
        payerSum += item.amount;
        takeAwayPayerSum += item.amount;
        cartSum += item.amount;
        // rabattSum += item.amount;
      } else if (item.type === 'discount') {
        discountValue += item.discount;
      }
    } else {
      cartSum += item.itemTotal;
      payerSum += item.itemTotal;
      // if (item.takeAwayItemTotal) {
      //     takeAwayPayerSum += item.takeAwayItemTotal;
      // } else {
      takeAwayPayerSum += item.itemTotal;
      // }
    }
  }

  if (payerSum < 0) {
    payerSum = 0;
  } else {
    //calculate amount from discountValue
    console.log('discountValue = ' + discountValue);
    // payerSum => 100%
    // x => discountValue
    //x = payerSum * discountValue / 100
    let discountAmount = payerSum * discountValue / 100;
    payerSum -= discountAmount;
    rabattSum += discountAmount;
  }

  if (takeAwayPayerSum < 0) {
    takeAwayPayerSum = 0;
  } else {
    //calculate amount from discountValue
    // payerSum => 100%
    // x => discountValue
    //x = payerSum * discountValue / 100
    let discountAmount = takeAwayPayerSum * discountValue / 100;
    takeAwayPayerSum -= discountAmount;
    // rabattSum += discountAmount;
  }

  if (payerSum < 0) {
    payerSum = 0;
  }
  if (takeAwayPayerSum < 0) {
    takeAwayPayerSum = 0;
  }

  cartSum = roundToTwo(cartSum);
  payerSum = roundToTwo(payerSum);
  takeAwayPayerSum = roundToTwo(takeAwayPayerSum);
  rabattSum = roundToTwo(rabattSum);

  return {
    cartSum: cartSum,
    payerSum: payerSum,
    takeAwayPayerSum: takeAwayPayerSum,
    rabattSum: rabattSum,
  };
}
